import { Card, CardContent } from "@mui/material";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import "../powerbi.css";

export const MarketAnalysisList = () => {
  return (
    <Card sx={{ margin: 2, height: "100%" }}>
      <CardContent
        sx={{
          height: "100%",
          padding: 0,
          "&:last-child": { paddingBottom: 0 },
        }}
      >
        <div style={{ height: "100%", width: "100%" }}>
          <PowerBIEmbed
            embedConfig={{
              type: "report",
              embedUrl:
                "https://app.powerbi.com/view?r=eyJrIjoiZWM3ZTI2MWItN2ZkMi00NjczLThlODItYWVkNWIwNjhlYWM0IiwidCI6IjFkYjBkZmU3LWNlNTAtNDZjZC05YmMwLWIzNjY3YzdmMjExZiJ9&chromeless=1&navContentPaneEnabled=false",
              accessToken: "",
              tokenType: models.TokenType.Embed,
              settings: {
                panes: {
                  filters: {
                    expanded: false,
                    visible: false,
                  },
                  pageNavigation: {
                    visible: false,
                  },
                },
                bars: {
                  actionBar: {
                    visible: false,
                  },
                },
                background: models.BackgroundType.Transparent,
              },
            }}
            eventHandlers={
              new Map([
                [
                  "loaded",
                  function () {
                    console.log("Market Analysis report loaded");
                  },
                ],
                [
                  "rendered",
                  function () {
                    console.log("Market Analysis report rendered");
                  },
                ],
                [
                  "error",
                  function (event) {
                    console.log("Market Analysis error:", event?.detail);
                  },
                ],
              ])
            }
            cssClassName="powerbi-report-container"
          />
        </div>
      </CardContent>
    </Card>
  );
};
